import type { Milestone } from '../types';

/**
 * Whether a milestone already carries this side's attestation decision. Used
 * when saving the decision failed or timed out: it may still have been saved,
 * and then the user is told so instead of retrying (ClickUp 869fgx15f). An
 * objection counts only once the milestone is actually under objection.
 */
export function attestationRegistered(
  milestone: Pick<Milestone, 'personAttestation' | 'companyAttestation' | 'deliveryStatus'> | undefined,
  side: 'person' | 'company',
  action: 'approved' | 'rejected'
): boolean {
  if (!milestone) return false;
  const decision = side === 'person' ? milestone.personAttestation : milestone.companyAttestation;
  return decision === action && (action !== 'rejected' || milestone.deliveryStatus === 'disputed');
}
